module.exports = __webpack_public_path__ + "img/favCart.d832b91f.svg";